export default __webpack_public_path__ + "static/media/mac-white-logo.2cf935c4.png";